import { ToneDto, ToneDtoImpl } from '../../tonedto';
import { NoDataException } from '../../../../utils/exceptions/nodataexistsexception';
import { DateFormat } from 'src/com/sixdee/crbtportal/ui/toolkit/dateformat/dateformat';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';

export class GetWishlistBuilder
{
    constructor(private getWishlistList: any, private context: BaseContext)
    {
        if(getWishlistList.toneDetailsList === undefined)
        {
            throw new NoDataException("Get Wishlist data doesnt exists");
        }
    }

    buildAll(): ToneDto[]
    {
        return this.parseGetWishlistDetailsResponse();
    }
    
    private parseGetWishlistDetailsResponse(): ToneDto[]
    {
        let listOfWishlistToneDetails: ToneDto[] = [];
        
        let tonedto = null;
        this.getWishlistList.toneDetailsList.forEach((toneDetailsItem: any) =>
        {
            tonedto = new ToneDtoImpl();
            tonedto.setId(toneDetailsItem.contentId);
            tonedto.setContentId(toneDetailsItem.id);
            tonedto.setToneName(toneDetailsItem.contentName);
            tonedto.setImgPath(toneDetailsItem.previewImageUrl);
            tonedto.setAlbumName(toneDetailsItem.album);
            tonedto.setArtistName(toneDetailsItem.artist);
            tonedto.setPrice(toneDetailsItem.price);
            tonedto.setToneUrl(toneDetailsItem.path);
            tonedto.setExpirydate(DateFormat.formatExpiryDate(toneDetailsItem.expiryDate, this.context));

            listOfWishlistToneDetails.push(tonedto);
        });
        return listOfWishlistToneDetails;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/wishlist/getwishlist/getwishlistbuilder.ts